/* Publish by EComposer at 2026-10-03 22:05:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xdcu5bfb5uq"]=  window.__ectimmers["ecom-xdcu5bfb5uq"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const o=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},n=function(){e.removeEventListener("mousemove",o),e.removeEventListener("mouseup",n),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",o),e.addEventListener("mouseup",n)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",n)}

                    });
                    
                        document.querySelectorAll('.ecom-xdcu5bfb5uq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdcu5bfb5uq', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}